import { type Board, type Clip, type Library } from '@air/api/types';

const isRecord = (data: unknown): data is Record<string, unknown> => typeof data === 'object' && data !== null;

const isLibraryDropData = (data: Record<string, unknown>): boolean =>
  typeof data.id === 'string' && typeof data.title === 'string' && !data.assetId && !('ancestors' in data);

export const droppedOnAsset = (data: unknown): data is Clip => isRecord(data) && Boolean(data.assetId);

export const droppedOnLibrary = (data: unknown): data is Library => isRecord(data) && isLibraryDropData(data);

export const droppedOnBoard = (data: unknown): data is Board =>
  isRecord(data) && 'id' in data && !data.assetId && !isLibraryDropData(data);

export const droppedOnRoot = (data: unknown) => !data;
